// extracted by mini-css-extract-plugin
export default {"solutionList__Style":"ItServices_solutionList__Style__dY8xF","trainingItem__style":"ItServices_trainingItem__style__8pmSM"};